<script>
    import {imask, MaskedInput} from 'svelte-imask';
    import Common from '../public/lib/common'
    import {createEventDispatcher} from 'svelte';

    let phone = "";
    let code = "";
    let phoneImaskOptions = {mask: '000000000'};
    let codeImaskOptions = {mask: 'aaaaaaaa'};

    let passwordMode = false;

    const dispatch = createEventDispatcher();

    function sendPhone() {
        Common.getLoginCode(phone).then(function (response) {
            if (response.granted) {
                passwordMode = true;
            } else {
                Common.error(response.code);
            }
        }).catch(function (present) {
            Common.error(JSON.stringify(present));
        });
    }

    function sendToken() {
        Common.getLoginToken(phone, code).then(function (response) {
            if (response.granted === true) {
                dispatch('logged', {uuid: response.code});
            } else {
                Common.error("");
            }
        }).catch(function (present) {
            Common.error(JSON.stringify(present));
        });
    }

</script>

<div class="m-auto form-signin">
    <div class="row">
        <div class="col-12 text-center">
            <img src="https://lms.biokinetica.com/img/biokinetica-logo.png" class="" alt="Logo"/>
        </div>
    </div>
    <div class="row mt-6">
        <input type="text" class="form-control text-center" placeholder="Nr telefonu" bind:value={phone}
               use:imask={phoneImaskOptions}/>
    </div>
    {#if passwordMode}
        <div class="row mt-6">
            <input type="text" class="form-control text-center" placeholder="Kod z SMSa" bind:value={code}
                   use:imask={codeImaskOptions}/>
        </div>
    {/if}
    <div class="row mt-6">
        <div class="col-12 text-center">
            {#if passwordMode}
                <button on:click={sendToken} type="button" class="btn btn-info">Wpisz kod z SMSa</button>
            {:else}
                <button on:click={sendPhone} type="button" class="btn btn-info">Wyślij mi hasło</button>
            {/if}
        </div>
    </div>
</div>

<style>
</style>
